function pickFirst(...values) {
  return values.find((v) => v !== undefined && v !== null && String(v).trim() !== '');
}

function buildProfileName(profile) {
  if (!profile) return '-';
  const firstName = pickFirst(profile.firstName, profile.first_name);
  const lastName = pickFirst(profile.lastName, profile.last_name);
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
  return fullName || pickFirst(profile.email, profile.uid) || '-';
}

export function mapPartnerDetailsResponseToDto(payload) {
  const partner = payload?.partner;
  if (!partner || typeof partner !== 'object') return null;

  return {
    uid: String(pickFirst(partner.uid) || '').trim(),
    status: pickFirst(partner.status) || '-',
    referralCode: pickFirst(partner.referralCode, partner.referral_code) || '-',
    referralToken: pickFirst(partner.referralToken, partner.referral_token) || '-',
    profileUid: String(pickFirst(partner?.profile?.uid, partner?.profile?.id) || '').trim(),
    profileName: buildProfileName(partner?.profile),
    parentUid: String(pickFirst(partner?.parent?.uid) || '').trim(),
    parentName: buildProfileName(partner?.parent?.profile),
    commissionPlanUid: String(pickFirst(partner?.commissionPlan?.uid) || '').trim(),
    commissionPlanName: pickFirst(partner?.commissionPlan?.name) || '-',
    walletUid: String(pickFirst(partner?.wallet?.uid) || '').trim(),
    walletBalanceMinor: String(partner?.wallet?.balance ?? ''),
    walletBalanceMicro: String(pickFirst(partner?.wallet?.balanceMicro, partner?.wallet?.balance) ?? ''),
    walletTotalEarnedMinor: String(partner?.wallet?.totalEarned ?? ''),
    walletTotalEarnedMicro: String(pickFirst(partner?.wallet?.totalEarnedMicro, partner?.wallet?.totalEarned) ?? ''),
    walletTotalWithdrawnMinor: String(partner?.wallet?.totalWithdrawn ?? ''),
    walletTotalWithdrawnMicro: String(pickFirst(partner?.wallet?.totalWithdrawnMicro, partner?.wallet?.totalWithdrawn) ?? ''),
    walletCurrency: pickFirst(partner?.wallet?.currency) || 'USD',
    created: pickFirst(partner.created, partner.createdAt, partner.created_at),
  };
}

export function mapPartnerTreeResponseToDto(payload) {
  const nodes = Array.isArray(payload?.nodes) ? payload.nodes : [];
  return nodes.map((node, index) => ({
    key: String(pickFirst(node.uid, `node-${index}`)),
    uid: String(pickFirst(node.uid) || '').trim(),
    name: pickFirst(node.name) || '-',
    depth: typeof node.depth === 'number' ? node.depth : 0,
    referralCount: typeof node.referralCount === 'number' ? node.referralCount : 0,
    monthlyEarningsMicro: node.monthlyEarningsMicro != null ? String(node.monthlyEarningsMicro) : '',
    monthlyEarningsMinor: node.monthlyEarnings != null ? String(node.monthlyEarnings) : '',
    currency: pickFirst(node.currency) || 'USD',
  }));
}

export function mapPartnerCommissionsResponseToDto(payload) {
  const commissions = Array.isArray(payload?.commissions) ? payload.commissions : [];
  return commissions.map((c, index) => ({
    key: String(pickFirst(c.uid, `commission-${index}`)),
    uid: String(pickFirst(c.uid) || '').trim(),
    type: pickFirst(c.type) || '-',
    status: pickFirst(c.status) || '-',
    depth: typeof c.depth === 'number' ? c.depth : 0,
    lots: c.lots != null ? String(c.lots) : '',
    amountMinor: String(c.amount ?? ''),
    amountMicro: String(pickFirst(c.amountMicro, c.amount) ?? ''),
    currency: pickFirst(c.currency) || 'USD',
    clientUid: String(pickFirst(c?.client?.uid, c?.client?.id) || '').trim(),
    clientName: buildProfileName(c?.client),
    created: pickFirst(c.created, c.createdAt, c.created_at),
  }));
}

export function mapPartnerReferralsResponseToDto(payload) {
  const referrals = Array.isArray(payload?.referrals) ? payload.referrals : [];
  const total = typeof payload?.total === 'number' ? payload.total : 0;

  return {
    referrals: referrals.map((row, index) => ({
      key: String(pickFirst(row?.profile?.uid, `referral-${index}`)),
      profileUid: String(pickFirst(row?.profile?.uid) || '').trim(),
      email: pickFirst(row?.profile?.email) || '-',
      fullName: buildProfileName(row?.profile),
      status: pickFirst(row?.profile?.status) || '-',
      created: pickFirst(row?.profile?.created, row?.created),
      accountsCount: typeof row?.accountsCount === 'number' ? row.accountsCount : 0,
    })),
    total,
  };
}
